// TODO: заменить frontend-справочник на backend options/human_payment_form
// Сейчас это fallback для ЭДО и UI, чтобы codes не попадали в документы
export const orderPaymentFormOptions = () => [
  { value: "cash", label: "Наличными" },
  { value: "with_vat", label: "С НДС" },
  { value: "without_vat", label: "Без НДС" },
];

export const orderPaymentFormLabels = () =>
  Object.fromEntries(
    orderPaymentFormOptions().map((option) => [
      option.value,
      option.label,
    ])
  );

export function orderPaymentFormLabel(value) {
  if (!value) return "";

  return orderPaymentFormLabels()[value] || value;
}
